export class BlueprintResponse {
}
export class BlueprintQuery {
}
export class Blueprint {
}
export class BlueprintData {
    constructor() {
        this.description = "";
        this.name = "";
        this.execution_message = "";
        this.prompt = "";
        this.type = "";
        this.io = "";
        this.piece_type = "";
        this.selected_toolpiece = "";
    }
}
export class ToolPieceData {
}
export class ListItem {
    constructor() {
        this.description = "";
        this.name = "";
        this.id = "";
    }
}
export class BlueprintStreaming {
}
export class Data {
}
export class Component {
}
export class MissingApis {
}
export class MissingApi {
}
